import * as React from "react";

function SvgIcons8Disconnected(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 32 32"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M27.281 3.281l-2.656 2.656-.438-.468A4.985 4.985 0 0020.657 4a4.985 4.985 0 00-3.532 1.469l-.719.687-.906.907-.781-.782L13.28 7.72l2.781 2.781-2.78 2.781 1.437 1.438 2.781-2.781 2.563 2.562-2.782 2.781 1.438 1.438 2.781-2.782 2.781 2.782 1.438-1.438-.782-.781 1.594-1.625a5.003 5.003 0 000-7.063l-.468-.437 2.656-2.656zM20.656 6c.766 0 1.535.285 2.125.875l2.344 2.344a2.994 2.994 0 010 4.25l-.25.219-1.375 1.374L16.937 8.5l1.594-1.625c.59-.59 1.36-.875 2.125-.875zM7.72 13.281L6.28 14.72l.782.781-1.594 1.625a5.003 5.003 0 000 7.063l.437.468-2.625 2.625L4.72 28.72l2.625-2.625.468.437a5.003 5.003 0 007.063 0l1.625-1.593.781.78 1.438-1.437zm.781 3.656l6.563 6.563-1.594 1.625a2.994 2.994 0 01-4.25 0L9 24.875l-2.125-2.094a2.994 2.994 0 010-4.25z" />
    </svg>
  );
}

export default React.forwardRef(SvgIcons8Disconnected);
